import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submit(event) {
    const overlay = document.querySelector('[data-controller="generation-overlay"]')
    if (overlay) {
      overlay.classList.remove('hidden')
    }
  }
} 